module.exports = __webpack_public_path__ + "img/ico_training_planning.54699465.png";